/* eslint-disable */
"use strict";

import { ODUtil } from "./../../components/util.js";

var ODLayoutSubheader = function() {
    // Private properties
    var _element;

    // Private functions
    var _getHeight = function() {
        var height = 0;

        if (_element) {
            height = ODUtil.actualHeight(_element);
        }

        return height;
    }

    // Public methods
	return {
		init: function(id) {
            _element = ODUtil.getById(id);

            if (!_element) {
                return;
            }
		},

        isFixed: function() {
            return ODUtil.hasClass(ODUtil.getBody(), 'subheader-fixed');
        },

        getElement: function() {
            return _element;
        },

        getHeight: function() {
            return _getHeight();
        }
	};
}();

// Webpack support
if (typeof module !== 'undefined') {
	// module.exports = ODLayoutSubheader;
}

export default ODLayoutSubheader;
